<template>
    <div class="col-md-6 offset-md-3">
        <h2>Confirm Property</h2>
        <div v-if="isVerified" class="invalid-feedback">Property has been verified</div>
        <div v-else class="invalid-feedback">{{errorMessage}}</div>
        
    </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { sameAsField } from '@/_helpers/validators';
import { router } from '@/_helpers';
import { authenticationService } from '@/_services';

export default {
    data(){
        return {
            username:"",
            password:"",
            confirmPassword:"",
            error: '',
            submitted:false,
            token:'',
            isVerified:false,
            errorMessage: '',
            firstName: '',
            lastName: '',
            role:'Owner'
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
      username: { required },
      password: { required },
      confirmPassword:{
          required,
          sameAsPassword:sameAsField('password')
      }
    },
    beforeCreate(){
       // authenticationService.logout();
    },
    mounted(){
        this.token = this.$route.params.token
        console.log(this.token)
        this.verifyAccount();
    },
     methods: {
        verifyAccount(){
            this.$http.get('/properties/confirmproperty?token='+this.token, {
                               
                            
                            }).then((response) => {
                                this.isVerified = true;
                                this.$router.push('/owner/properties')
                            }).catch(err => console.log(err.message))

                        
        },
        
    }
}
</script>